export const AccountMethods = {
  Keycloak: "keycloak",
  Guest: "guest",
  IAM: "iam",
  Conf2: "conf2"
} as const;
